import React from "react";
import { Link } from "react-router-dom";
import { TypeAnimation } from 'react-type-animation';
import CountUp from 'react-countup';
import * as Unicons from '@iconscout/react-unicons';

export default function HeroOne() {
    return (
        <>
            <section className="relative pt-28 personal-wrapper overflow-hidden bg-amber-500/5" id="home">
                <div className="absolute inset-0,mt-20" id="overlay" ></div>
                <div className="container">
                    <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[10px]">
                        <div>
                            <h4 className="font-bold lg:text-[40px] text-3xl lg:leading-normal leading-normal mb-4">Hey! I'm <br />
                           

                                <TypeAnimation
                                    sequence={[
                                        // Same substring at the start will only be typed out once, initially
                                        'Pramod John',
                                        1000, // wait 1s before replacing "Mice" with "Hamsters"
                                        'CEO & Founder, Demetrix Infotech',
                                        1000,
                                        // 'Demetrix Infotech',
                                        // 1000,
                                        // 'UI/UX Designer',
                                        // 1000
                                    ]}
                                    wrapper="span"
                                    speed={50}
                                    className="typewrite text-amber-500"
                                    repeat={Infinity}
                                />
                                <span className="typewrite text-amber-500" data-period="2000" data-type='[ "Demetrix Infotech", "CEO & Founder", "Demetrix Infotech"]'> <span className="wrap"></span> </span></h4>
                               {/* <div className="flex items-center gap-20 mt-8">
    <a
        href="https://www.facebook.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-amber-500 hover:text-white text-2xl p-8 rounded-full hover:bg-amber-600 transition"
    >
        <Unicons.UilFacebookF />
    </a>

    <a
        href="https://twitter.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-amber-500 hover:text-white text-2xl p-8 rounded-full hover:bg-amber-600 transition"
    >
        <Unicons.UilTwitter />
    </a>

    <a
        href="https://www.linkedin.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-amber-500 hover:text-white text-2xl p-8 rounded-full hover:bg-amber-600 transition"
    >
        <Unicons.UilLinkedin />
    </a>

    <a
        href="https://www.instagram.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-amber-500 hover:text-white text-2xl p-8 rounded-full hover:bg-amber-600 transition"
    >
        <Unicons.UilInstagram />
    </a>
</div> */}


                            {/* <p className="text-slate-400 max-w-xl">Obviously I'm a Web Designer. Web Developer with over 7 years of experience. Experienced with all stages of the development.</p> */}

                            {/* <div className="mt-6">
                            <Link to="" className="btn bg-amber-500 hover:bg-amber-600 border-amber-500 hover:border-amber-600 text-white rounded-md">Hire Me</Link>
                            <Link to="" className="btn bg-amber-500/10 hover:bg-amber-500 border-amber-500/10 hover:border-amber-500 text-amber-500 hover:text-white rounded-md ms-1">Download CV</Link>
                        </div> */}
                        </div>
                        

                        <div className="relative">
                      <img
  src="/images/hero/download.jpeg"
  alt=""
  className="w-48 h-48 object-cover rounded-full border-2 border-yellow-100"
/>



                            {/* <div className="absolute lg:bottom-20 md:bottom-10 bottom-2 ltr:md:-left-5 ltr:left-2 rtl:md:-right-5 rtl:right-2 p-4 rounded-lg shadow-md dark:shadow-gray-800 bg-white dark:bg-slate-900 m-3 w-44 text-center">
                            <span className="text-3xl font-medium mb-0"><span className="counter-value font-bold" data-target="125"> <CountUp
                                            start={7}
                                            className="counter-value"
                                            end={180}
                                            duration={2.75} /></span>+</span>
                            <h6 className="text-sm text-slate-400 mt-1">Project Completed</h6>
                        </div> */}

                            {/* <div className="absolute lg:top-80 md:top-56 top-48 ltr:md:-right-0 ltr:right-2 rtl:md:-left-0 rtl:left-2 p-4 rounded-lg shadow-md dark:shadow-gray-800 bg-white dark:bg-slate-900 m-3 w-44 text-center">
                            <h6 className="font-semibold">Web Designer</h6>
                            <h6 className="text-sm text-slate-400 mt-1">7+ Years Experience</h6>
                        </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* <div className="relative">
            <div className="absolute block w-full h-auto bottom-[25px] z-1 left-0">
                <Link to="#about"><i className="mdi mdi-arrow-down absolute top-0 left-0 right-0 text-center inline-flex items-center justify-center rounded-full bg-white dark:bg-slate-900 h-12 w-12 mx-auto shadow-md dark:shadow-gray-800"></i></Link>
            </div>
        </div> */}
        </>
    )
} 